<template>
  <div>
    <div class="user-top">
      <i-row class="tmp-row">
        <i-col :xs="24" :sm="24" :md="18" :lg="20" class="user-search">
          <i-input
            placeholder="模糊搜索"
            style="width: 200px;margin: 0 auto;"
            v-model="searchKey"
            clearable
            @on-clear="searchKeyClear"
            @keyup.enter.native="serachBtn"
          />
          <i-button type="info" icon="md-search" class="search" @click="serachBtn">搜索</i-button>
        </i-col>
        <i-col :xs="24" :sm="24" :md="6" :lg="4">
          <i-button type="success" class="article-button" @click="addTemplate">
            <i class="iconfont icon-tianjia"></i>
            新增
          </i-button>
        </i-col>
      </i-row>
    </div>
    <div class="user-main">
      <i-table class="user-table" :columns="columns" :data="templateData" ref="table" stripe border>
        <template slot="attributes" slot-scope="{ row }">
          <div class="attribute-attr" v-for="(item, index) in row.attributes" :key="index">
            <span v-if="item.split('__')[1] === 'string'">{{ item.split("__")[2] }}</span>
            <span v-else-if="item.split('__')[1] === 'file'">{{ item.split("__")[3] }}</span>
            <span v-if="index < row.attributes.length - 1">,</span>
          </div>
        </template>
        <template slot="operate" slot-scope="{ row }">
          <i-button type="info" class="article-button" @click="showPreviewTemplateModal(row)">
            <i class="el-icon-view operate-icon"></i>
            预览
          </i-button>
          <i-button type="warning" class="article-button" @click="editTemplate(row)">
            <i class="iconfont icon-weibiaoti2010104 operate-icon"></i>
            编辑
          </i-button>
          <i-button type="error" class="article-button" @click="deleteTemplate(row)">
            <i class="iconfont icon-lajitong operate-icon"></i>
            删除
          </i-button>
        </template>
      </i-table>
      <!-- 分页插件 -->
      <i-page
        :total="total"
        :page-size-opts="[10, 20, 30, 40, 50, 100]"
        size="small"
        show-elevator
        show-sizer
        show-total
        placement="top"
        :current="current"
        :page-size="pageSize"
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
      />
    </div>
    <!-- loading-->
    <div v-if="showLoading" class="demo-spin-col" span="8">
      <i-spin fix>
        <i-icon type="ios-loading" size="18" class="demo-spin-icon-load"></i-icon>
        <div>Loading</div>
      </i-spin>
    </div>
    <add-template-modal :is-show="isShowAddTemplate" @cancel="cancel" @success="success" />
    <edit-template-modal :is-show="isShowEditTemplate" :edit-data="editData" @cancel="cancel" @success="success" />
    <preview-template-modal :is-show="isShowPreviewTemplate" :preview-data="previewData" @cancel="cancel" />
  </div>
</template>

<script>
import PreviewTemplateModal from "./Template/PreviewTemplateModal.vue"
import AddTemplateModal from "./Template/AddTemplateModal"
import EditTemplateModal from "./Template/EditTemplateModal"
import { baseConfigMixin } from "./mixin"
export default {
  name: "Template",
  components: {
    EditTemplateModal,
    AddTemplateModal,
    PreviewTemplateModal,
  },
  mixins: [baseConfigMixin],
  data() {
    return {
      total: 10,
      current: 1,
      pageSize: null,
      columns: [
        {
          type: "selection",
          width: 30,
          align: "center",
          resizable: true,
        },
        {
          title: "模板名",
          key: "name",
          width: 150,
          align: "center",
          resizable: true,
        },
        {
          title: "简介",
          key: "desc",
          minWidth: 100,
          align: "center",
          resizable: true,
        },
        {
          title: "内容",
          key: "content",
          minWidth: 100,
          align: "center",
          resizable: true,
        },
        {
          title: "参数",
          key: "attributes",
          slot: "attributes",
          minWidth: 100,
          align: "center",
        },
        {
          title: "操作",
          key: "operate",
          slot: "operate",
          width: 300,
          align: "center",
        },
      ],
      searchKey: "",
      templateData: [],
      currentUserTokenData: {},
      showLoading: true,
      isShowPreviewTemplate: false,
      isShowAddTemplate: false,
      isShowEditTemplate: false,
      isShowDeleteTemplate: false,
      previewData: {
        attributes: [],
      },
      editData: {},
    }
  },
  methods: {
    cancel() {
      this.isShowPreviewTemplate = false
      this.isShowAddTemplate = false
      this.isShowEditTemplate = false
      this.isShowDeleteTemplate = false
      this.editData = {}
      this.previewData = {
        attributes: [],
      }
    },
    success() {
      this.cancel()
      this.getTemplateList()
    },
    // page改变事件
    pageChange(index) {
      this.current = index
      this.getTemplateList()
    },
    pageSizeChange(size) {
      this.pageSize = size
      localStorage.setItem("pageSize", size)
      this.$store.commit("changePageSize", size)
      this.getTemplateList()
    },
    // 搜索
    serachBtn() {
      this.current = 1
      this.getTemplateList()
    },
    searchKeyClear() {
      this.current = 1
      this.getTemplateList()
    },
    //获取列表
    async getTemplateList() {
      
      let self = this
      self.showLoading = true
      let xData = {}
      xData = {
        p: this.current,
        p_size: this.pageSize,
      }
      if (this.searchKey) {
        xData["search_key"] = this.searchKey
      }
      try {
        const res = await self.axios({
          method: "get",
          url: self.cmsUrl + "api/content/template/list",
          params: {
            ...xData,
          },
        })
        if (!res) {
          return
        }
        if (res.data.code === 0) {
          self.templateData = []
          self.templateData.push(...res.data.data.data)
          self.total = res.data.data.total
          self.showLoading = false
        } else {
          self.showLoading = false
          self.$Message.error("操作失败，错误原因：" + res.data.error_message)
          console.log(res)
        }
      } catch (err) {
        self.showLoading = false
        self.$Message.error("操作失败，错误原因：" + err)
        console.log(err)
      }
    },
    addTemplate() {
      this.isShowAddTemplate = true
    },
    editTemplate(row) {
      this.editData = row
      this.isShowEditTemplate = true
    },
    deleteTemplate(row) {
      const self = this
      this.$Modal.confirm({
        title: "确认",
        content: "<p>要删除" + row.name + "吗？</p>",
        onOk: async () => {
          self.showLoading = true
          try {
            const res = await self.axios({
              method: "delete",
              url: self.cmsUrl + "api/content/template/delete",
              params: {
                tids: [row.id],
              },
            })
            if (!res) {
              return
            }
            if (res.data.code === 0) {
              self.showLoading = false
              self.$Message.success("删除成功！")
              self.success()
            } else {
              self.showLoading = false
              self.$Message.error("操作失败，错误原因：" + res.data.error_message)
              console.log(res)
            }
          } catch (err) {
            self.showLoading = false
            self.$Message.error("操作失败，错误原因：" + err)
            console.log(err)
          }
        },
      })
    },
    showPreviewTemplateModal(row) {
      this.isShowPreviewTemplate = true
      this.previewData = row
    },
  },
  mounted() {
    if (localStorage.pageSize === undefined) {
      this.pageSize = 10
    } else {
      this.pageSize = Number(localStorage.pageSize)
    }
    if (this.$route.query.searchKey !== undefined) {
      this.searchKey = this.$route.query.searchKey
    }
    this.getTemplateList()
  },
}
</script>

<style scoped>
.user-top {
  margin-top: 10px;
  margin-bottom: 10px;
}
.title {
  text-align: center;
}
/* .user-button {
  margin-left: -200px;
} */
.user-search {
  min-width: 302px;
}

.user-search .search {
  margin-left: 20px;
}

.user-main {
  padding: 0 20px;
}

.article-button {
  margin-right: 5px;
}

>>> .ivu-table-cell {
  padding: 5px !important;
}

>>> .ivu-tooltip-inner {
  border: 1px solid white;
}

.user-table {
  overflow: visible !important;
}
.attribute-attr {
  display: inline-block;
}
.operate-icon {
  margin-right: 5px;
}
.tmp-row {
  width: 100%;
  margin: 18px 0;
}
</style>

<style lang="scss">
/* 让modal居中 */
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
</style>
